import { PositionedQuestionModuleRequest, QuestionModuleDto, } from '../questionModuleTypes';

export interface BaseQuestionCatalogue {
  title: string,
}

export interface QuestionCatalogueRequest extends BaseQuestionCatalogue{
  modules: PositionedQuestionModuleRequest[]
}

export interface QuestionCatalogueDto extends BaseQuestionCatalogue {
  id: number,
  modules: QuestionModuleDto[]
}

export function emptyQuestionCatalogueRequest(): QuestionCatalogueRequest {
  return {
    title: '',
    modules: []
  }
}

export function emptyQuestionCatalogue(): QuestionCatalogueDto {
  return {
    id: -1,
    title: '',
    modules: []
  }
}
